export const CODE_FIELD = 'Code';
export const HTML_SETTING = 'html';
export const VALUE_FOR_THIS_KEY = 'valueForThis';
export const ARGUMENTS_KEY = 'arguments';
